import React from 'react';
import './people.scss';

import type { Person } from '../../../content/types/person';
import { PersonCard } from './PersonCard';

interface PeopleType {
  people: Person[];
}

export const People: React.FC<PeopleType> = (props) => {
  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 people-container">
      {props.people.map((person) => (
        <div key={person.id} className="col">
          <PersonCard {...person} />
        </div>
      ))}
    </div>
  );
};
